<template>
<section id="dashboard-ecommerce">
    <b-row class="match-height">
      <b-col xl="3" md="6" >
       <ListaEstabelecimento></ListaEstabelecimento>
      </b-col>
      <b-col xl="9" md="6" >
        <TabEstabelecimento ></TabEstabelecimento>
      </b-col>
     
    </b-row>

</section>


</template>

<script>
import { BCard, BCardText, BLink,BRow, BCol } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import ListaEstabelecimento from "./estabelecimentos/ListaEstabelecimento.vue";
import TabEstabelecimento from "./estabelecimentos/TabEstabelecimento.vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    ListaEstabelecimento,
    TabEstabelecimento,
},

  data() {
    return {
      lista: [],
      status: "",
      password: "",
      show: false,
      isDisabled: true,

    };
  },

  created() {
    // this.$store.dispatch("estabelecimentos/all_estabelecimentos");
  },
  computed: {
    estabelecimento() {
        return this.$store.state.estabelecimentos.estabelecimento.allEstablishment;
    },
    usuario() {
      return this.$store.state.login.usuario;
    },
    lista_estabelecimentos() {
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },
    mensagem_alert() {
      return this.$store.state.configEmpresa.mensagem_alert;
    },
  },

  methods: {
  async  SalvarEstabelecimento(){
    this.isDisabled = true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {

            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false
         
        })
        .catch((error) => {
          this.isDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
      this.isDisabled = false;
      this.show = true;
    },
  },
};
</script>


<style  scoped>
</style>